"use strict";

/**
 * Location params
 */
var _window$location = window.location,
    protocol = _window$location.protocol,
    host = _window$location.host,
    pathname = _window$location.pathname;
var needsNormalization = pathname[pathname.length - 1] === '/';
var normalizedPath = needsNormalization ? pathname.substring(0, pathname.length - 1) : pathname;
/**
 * Default configuration
 * @see https://github.com/mzabriskie/axios#request-config
 */

module.exports = {
  baseURL: "".concat(protocol, "//").concat(host).concat(normalizedPath, "/api"),
  method: 'get',
  timeout: 3000,
  responseType: 'json',
  maxRedirects: 0,
  sendCSRFToken: true
};
